import { createRoot } from 'react-dom/client'
import '@/utils/sentry.ts'
import App from './App.tsx'
createRoot(document.getElementById('root')!).render(<App />)
